module.exports = __webpack_public_path__ + "img/BankCard.fe6d8a7f.png";